export default __webpack_public_path__ + "static/NotoSans-ExtraBold-a4dc753f55a7591fa2d1d10e36dbca26.ttf";